import type { Thunk } from 'editor/src/store/hooks';

import { getLibraryRequest } from '../selector';

import removeImageFromLibraryOperation from './removeImageFromLibraryOperation';
import saveImageToLibraryOperation from './saveImageToLibraryOperation';

const retryLibraryRequestOperation =
  (imageId: string): Thunk =>
  (dispatch, getState) => {
    const request = getLibraryRequest(getState(), imageId);
    if (request?.status !== 'failed') {
      return;
    }
    dispatch(request.saved ? saveImageToLibraryOperation(imageId) : removeImageFromLibraryOperation(imageId));
  };

export default retryLibraryRequestOperation;
